import { PlanTemplateType } from "../../templates/generated/template_types";
import type { FlowTemplateData } from "../../templates/generator/types";
import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
  PlanType,
} from "../../templates/types";

// Used when creating Planiras from Custom templates
export function convertTemplateToPlanira(
  input: FlowTemplateData,
): PlaniraTemplate {
  return {
    planType: PlanType.Quickstart,
    type:
      input.type === "wizard"
        ? PlanTemplateType.Wizard
        : PlanTemplateType.CustomTemplate,
    title: input.title,
    titleHelp: input.titleHelp,
    suggestedTitles: input.suggestedTitles ?? [],
    description: input.description,
    longDescription: "",
    emoji: input.emoji,
    imageType: input.imageType ?? PlaniraPlanImage.Party,

    // image?: string;

    sections: [
      {
        section: {
          isExpandable: false,
          isDraggable: false,
        },
        modules: [
          {
            type: ModuleType.PlanInfo,
            doneType: ModuleDoneType.None,
            title: input.title,
            emoji: input.emoji,

            descriptionYooptaEditor: input.descriptionYooptaEditor ?? null,
            coverUrl: input.coverUrl ?? null,
            backgroundColor: input.backgroundColor ?? null,
          },
        ],
      },
      {
        section: {
          title: "Ongoing",
        },
        modules: input.modules ?? [],
      },
    ],

    onTemplateComplete: input.onTemplateComplete,
  };
}
